import { palette } from "./palette";

const STANDARD_BORDER = `1px solid ${palette.gray20}`;

export const standardBorder = { border: STANDARD_BORDER };
export const standardBorderTop = { borderTop: STANDARD_BORDER };
export const standardBorderLeft = { borderLeft: STANDARD_BORDER };
export const standardBorderRight = { borderRight: STANDARD_BORDER };
export const standardBorderBottom = { borderBottom: STANDARD_BORDER };
